// const SITE = localStorage.getItem('site') ? JSON.parse(localStorage.getItem('site')) : ['ok9']; // phương pháp lấy dữ liệu từ localStorage chưa hợp lý. cần update sau
import { SITE } from '../../config/config';

export const LocalStorageKey = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info'
};

export const ENUM_ROLE = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE'
};

export const ENUM_TYPE_MESS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
};

export const CONST_SYS = {
  PASS_RESET: '@@okvip@@'
};

export const LIST_SITE = [SITE];

export const ENUM_WC_PREDICTION = {
  VO_DICH: 'doi_vo_dich',
  VUA_PHA_LUOI: 'vua_pha_luoi',
  DOI_BI_LOAI_DAU_TIEN: 'doi_bi_loai_first',
  CAU_THU_XUAT_SAC: 'player_mvp',
  FIRST_16_ROUND: 'first_16_round',
  FIRST_32_ROUND: 'first_32_round',
  FINAL_ASIA_TEAM: 'final_asia_team',
  FIRST_RED_CARD: 'first_redcard_team'
};

export const MAP_NAME_PREDICT_WC = Object.freeze({
  [ENUM_WC_PREDICTION.VO_DICH]: 'Đội vô địch',
  [ENUM_WC_PREDICTION.VUA_PHA_LUOI]: 'Vua phá lưới',
  [ENUM_WC_PREDICTION.DOI_BI_LOAI_DAU_TIEN]: 'Đội bị loại đầu tiên',
  [ENUM_WC_PREDICTION.CAU_THU_XUAT_SAC]: 'Cầu thủ xuất sắc',
  [ENUM_WC_PREDICTION.FINAL_ASIA_TEAM]: 'Đội châu Á vào sâu nhất'
});

export const MAP_NAME_PREDICT_WC_TEAM = Object.freeze({
  [ENUM_WC_PREDICTION.VO_DICH]: 'Đội vô địch',
  [ENUM_WC_PREDICTION.DOI_BI_LOAI_DAU_TIEN]: 'Đội bị loại đầu tiên',
  [ENUM_WC_PREDICTION.FINAL_ASIA_TEAM]: 'Đội châu Á vào sâu nhất'
});

export const MAP_NAME_PREDICT_WC_PLAYER = Object.freeze({
  [ENUM_WC_PREDICTION.VUA_PHA_LUOI]: 'Vua phá lưới',
  [ENUM_WC_PREDICTION.CAU_THU_XUAT_SAC]: 'Cầu thủ xuất sắc'
});

export const SETTING_KEYS = {
  TITLE: 'title',
  NO_DATA: 'no-data',
  TEXT_RUN: 'text_run',
  LINK_HOME: 'link_home',
  LINK_LOGIN: 'link_login',
  LINK_DOWNLOAD_APP: 'link_download_app',
  LINK_REGISTER: 'link_register',
  PRIZE_STRUCTURE: 'prize_structure',
  RULE: 'rule',
  RANK_MATCH: 'rank_match'
};

export const information = {
  // endpoint: "https://api-bottkm.khuyenmaiapp.com",
  endpoint: 'http://localhost:5555',
  //endpoint: process.env.REACT_APP_STORAGE_URL,
  // endpoint_bo_789bet: "https://api-ttkm-bo_789bet-v3.attapps.net",
  endpoint_bo_789bet: process.env.REACT_APP_STORAGE_URL,
  endpoint_xf: process.env.REACT_APP_STORAGE_URL,
  // endpoint_xuxian: "http://localhost:7070",
  role_detail: [
    { role: 'phone', detail_label: 'Xem số điện thoại khách' },
    { role: 'approve', detail_label: 'Duyệt đơn' },
    { role: 'deny', detail_label: 'Từ chối đơn' },
    { role: 'lock', detail_label: 'Khóa đơn' },
    { role: 'rule', detail_label: 'Cấu hình khuyến mãi' },
    { role: 'message', detail_label: 'Chỉnh sửa thư gửi' },
    { role: 'account_manager', detail_label: 'Quản trị quyền truy cập và người dùng' },
    { role: 'whitelist', detail_label: 'IP whitelist' },
    { role: 'download', detail_label: 'Tải danh sách' },
    { role: 'readOnly', detail_label: 'Chỉ xem đơn cụ thể (không xem tất cả)' }
  ],
  secret_key_encrypt: 'haudai@att$$',
  localhostSite: process.env.REACT_APP_SITE
};
